import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { comics } from '@/mocks/comics';
import useScrollToTop from '@/hooks/useScrollToTop';

export default function Home() {
  useScrollToTop();

  const popularComics = comics.filter(c => c.views > 1500000).slice(0, 4);
  const latestComics = [...comics].sort((a, b) =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫之家 - 免费韩漫在线观看',
    description: '在韩漫之家，您可以免费在线观看下拉式韩漫大全，畅读各种作品，享受流畅的浏览功能。',
    url: 'https://www.manhuazhijia.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫之家',
      url: 'https://www.manhuazhijia.com/',
    },
  };

  return (
    <>
      <SEOHead
        title="免费韩漫_韩漫在线观看_下拉式韩漫大全-韩漫之家"
        description="在韩漫之家，您可以免费在线观看下拉式韩漫大全，畅读各种作品，享受流畅的浏览功能，轻松探索人气漫画并随时追更最新章节内容。"
        keywords="免费韩漫,韩漫在线观看,下拉式韩漫大全,韩漫之家,韩漫免费阅读"
        canonicalUrl="https://www.manhuazhijia.com/"
        schemaData={[webPageSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />

        <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  热门推荐
                </h2>
                <p className="text-foreground-500 text-sm mt-2">最受读者欢迎的韩漫作品</p>
              </div>
              <Link
                to="/category/all"
                className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-product-shop>
              {popularComics.map((comic) => (
                <ComicCard key={comic.id} {...comic} coverImage={comic.coverImage} />
              ))}
            </div>
          </div>
        </section>

        <CategorySection />

        <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  最新更新
                </h2>
                <p className="text-foreground-500 text-sm mt-2">刚刚更新的最新章节，快来追更</p>
              </div>
              <Link
                to="/category/all"
                className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5" data-product-shop>
              {latestComics.map((comic) => (
                <ComicCard key={comic.id} {...comic} coverImage={comic.coverImage} />
              ))}
            </div>
          </div>
        </section>

        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}